export default function imageLoader({ src, width, quality = 75 }) {
  return `${process.env.NEXT_PUBLIC_IMAGES_URL}${src}?w=${width}&q=${quality}`
}
